<template>
  <div class="Matters">
    <van-nav-bar title="调研填报" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="matterCon">
      <div class="navslist">
        <div class="navli" style="color: #fff;">基础填报</div>
        <div class="navli">文件上传</div>
        <div class="navli">填报完成</div>
      </div>
      <div class="mmhead">
        <div class="nng">{{ question.name }}</div>
      </div>
      <van-cell-group ontset>
        <template v-for="(li,index) in question.question_data" :key="index">
          <div class="van-multi-ellipsis--l2" style="margin: 10px 10px;    padding-top: 12px;">
            {{ li.label }}
            <template v-if="li.unit!=null&&li.unit!=''">(单位：{{ li.unit }})</template>
          </div>
          <van-field v-if="li.type=='文本'" v-model="li.value" :placeholder="li.remarks" label-width="100px"/>
          <van-field v-if="li.type=='数字'" v-model="li.value" :placeholder="li.remarks" type="number"
                     label-width="100px"/>
          <van-field v-if="li.type!='文本'&&li.type!='数字'" name="radio" label-width="130px">
            <template #input>
              <van-radio-group v-model="li.value" direction="horizontal">
                <!--                <van-radio style="padding: 3px;" name="否">否</van-radio>-->
                <van-radio style="padding: 3px;" v-for="option in li.options" :key="option" :name="option">
                  {{ option }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </template>
      </van-cell-group>
      <van-sticky :offset-bottom="0" position="bottom">
        <div class="nextbtn">
          <van-button type="primary" @click="clickNext" block round size="large" color="#2f58e4">下一步</van-button>
        </div>
      </van-sticky>
    </div>

  </div>
</template>

<script>
import {baseUrl, cache, post} from "../api/http"
import {Dialog} from "vant";
import moment from 'moment';
import {ref} from 'vue';

export default {
  name: "MattersCon",
  setup() {
    const result = ref('');
    const showPicker = ref(false);
    const columns = ['装备制造1', '装备制造2', '装备制造3', '装备制造4', '装备制造5'];
    const checked = ref('1');
    // return { checked };
    const onConfirm = (value) => {
      result.value = value;
      showPicker.value = false;
    };

    return {
      checked,
      result,
      columns,
      onConfirm,
      showPicker,
    };
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      question: {
        question_data: [],
      },
    }
  },
  mounted() {
    var question = cache("question")
    for (var i = 0; i < question.question_data.length; i++) {
      this.checkedType(question.question_data[i])
    }
    this.question = question
  },
  watch: {
    // question: {//深度监听，可监听到对象、数组的变化
    //   handler() {
    //
    //       // cache("question",this.question)
    //   },
    //   deep: true //true 深度监听
    // }

  },
  methods: {
    clickNext() {
      for (var i = 0; i < this.question.question_data.length; i++) {
        if (this.question.question_data[i].value == null || this.question.question_data[i].value == "") {
          Dialog({message: "你还没有填报“" + this.question.question_data[i].label + "”项内容"})
          return
        }
      }
      var that = this
      cache("question", this.question)
      post("app/question/update", {
        id: this.question.id,
        status: 1,
        question_data: JSON.stringify(this.question.question_data)
      }).then(function () {

        that.$router.push({'path': '/matterUp'})
      })

    },
    checkedType(li) {

      if (li.type.indexOf("/") != -1) {
        console.log(454545)
        var strs = li.type.split("/");
        li.options = [];
        var hasnot = false
        for (var i = 0; i < strs.length; i++) {
          if (strs[i] != "") {
            li.options.push(strs[i])
          }
          if (strs[i] == "否") {
            hasnot = true
          }
        }
        if (hasnot == false) {
          li.options = ["否", ...li.options]
        }

      }

    },
    getTime(unixTime) {

      return moment(unixTime * 1000).format("YYYY-MM-DD HH:mm:ss");
    },

    setImg(src) {
      if (src == null || src == "") {
        return "./img/logo.png"
      }
      return baseUrl + "/" + src
    },
    onClickLeft: () => history.back(),
  },
}
</script>

<style scoped>
.mmhead {
  padding: 30px;
  margin-top: 10px;
  background: #fff
}

.mattertitle h1 {
  font-size: 16px
}

.mdate span {
  font-size: 14px;
  margin-left: 10px
}

.nextbtn {
  padding: 0 30px 30px;
  margin: 20px 0
}

.navslist {
  height: 40px;
  background: #fff;
}

.navli {
  text-align: center;
  height: 40px;
  line-height: 40px;
  background: #fff;
  display: inline-block;
  width: 33.3%;
}

.navslist .navli:first-child {
  background: url("../assets/img/po2.png") no-repeat;
  background-size: 100% 100%;
}

.navslist .navli:nth-child(2) {
  background: url("../assets/img/poo1.png") no-repeat;
  background-size: 100% 100%;
}

.nng {
  padding-bottom: 5px;
  font-size: 16px;
  font-weight: bold
}


</style>

